import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=a9b5c956&scoped=true&"
import script from "./ProfilePicture.vue?vue&type=script&lang=js&"
export * from "./ProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=a9b5c956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5c956",
  null
  
)

export default component.exports